const validarDocumento = (val, tipoDocumento = 'CPF') => {
    val = removeCaracteresEspeciais(val);

    switch (tipoDocumento.toUpperCase()) {
        case 'RUC':
            return validarRuc(val);
        case 'CNPJ':
            return validarCNPJ(val);
        case 'CPF':
        default:
            return val.length === 11 ? validarCPF(val) : validarCNPJ(val);
    }
};

const validarCNPJ = cnpj => {
    if (
        !cnpj ||
        cnpj.length !== 14 ||
        cnpj.split('').every(c => c === cnpj[0])
    ) {
        return false;
    }

    const cnpjNumeros = cnpj.split('');
    const multiplicadores1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const multiplicadores2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    const digito1 = calculaDigitoVerificador(
        cnpjNumeros.slice(0, 12),
        multiplicadores1
    );
    const digito2 = calculaDigitoVerificador(
        cnpjNumeros.slice(0, 13),
        multiplicadores2
    );

    return (
        digito1 === parseInt(cnpjNumeros[12], 10) &&
        digito2 === parseInt(cnpjNumeros[13], 10)
    );
};

const validarCPF = cpf => {
    if (!cpf || cpf.length !== 11 || cpf.split('').every(c => c === cpf[0])) {
        return false;
    }

    const cpfNumeros = cpf.split('');
    const digito1 = calculaDigitoVerificador(
        cpfNumeros.slice(0, 9),
        Array.from({ length: 9 }, (_, i) => 10 - i)
    );
    const digito2 = calculaDigitoVerificador(
        cpfNumeros.slice(0, 10),
        Array.from({ length: 10 }, (_, i) => 11 - i)
    );

    return (
        digito1 === parseInt(cpfNumeros[9], 10) &&
        digito2 === parseInt(cpfNumeros[10], 10)
    );
};

const validarNomePessoa = val => {
    const regex = /^[a-zA-Z]+\s[a-zA-Z]+$/;
    if (val && val.length >= 3 && regex.test(val)) {
        return true;
    }

    return false;
};

const validarRuc = ruc => {
    if (ruc.length !== 8 && ruc.length !== 9) {
        return false;
    }

    return true;
};

const removeCaracteresEspeciais = val => val.trim().replace(/[.\-/]/g, '');

const transformaCharParaNumero = char => /\d/.test(char) ? parseInt(char, 10) : char.charCodeAt(0) - 48;

const calculaDigitoVerificador = (numeros, multiplicadores) => {
    let soma = 0;
    numeros.forEach((numero, index) => {
        soma += transformaCharParaNumero(numero) * multiplicadores[index];
    });
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
};

const validarEmail = val => {
    var re = /\S+@\S+\.\S+/;
    return re.test(val);
};

export default {
    validarDocumento,
    validarCPF,
    validarCNPJ,
    validarRuc,
    validarNomePessoa,
    validarEmail
};
